import React from "react";
import styled from "styled-components";
import { CheckCircleOutlined } from "@ant-design/icons";

const TourConfirmedCard = ({ address, whenLabel }) => {
  return (
    <Card>
      <Header>
        <IconWrap>
          <CheckCircleOutlined />
        </IconWrap>
        <div>
          <Title>Tour Confirmed</Title>
          <Subtitle>{whenLabel}</Subtitle>
        </div>
      </Header>
      {address ? <Address>{address}</Address> : null}
    </Card>
  );
};

export default TourConfirmedCard;

const Card = styled.div`
  width: 100%;
  background: rgba(44, 95, 45, 0.05);
  border: 1px solid rgba(44, 95, 45, 0.18);
  border-radius: 12px;
  padding: 12px;
`;

const Header = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

const IconWrap = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(44, 95, 45, 0.12);
  color: var(--color-primary-dark);
  flex-shrink: 0;
`;

const Title = styled.div`
  font-weight: 800;
  color: var(--color-primary-dark);
  line-height: 1.2;
`;

const Subtitle = styled.div`
  color: var(--color-text);
  font-weight: 600;
  font-size: 0.92rem;
  margin-top: 2px;
`;

const Address = styled.div`
  margin-top: 10px;
  color: var(--color-text-secondary);
  font-size: 0.9rem;
  line-height: 1.35;
`;
